import React, { useState } from "react";
// import Grid from "@mui/material/Grid";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
// import { Link } from "react-router-dom";
import {
  Autocomplete,
  Box,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import white from "../../../Assets/Images/whitebg.jpg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Button } from "@material-ui/core";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { BoltRounded } from "@mui/icons-material";
export default function Index() {



  const GridHeadings = [
    {
      name: "Detail of Private Rating (vendor assessment)",
      link: "pvtratings",
      dateModel: "double",
      id: "1",
    },

    {
      name: "New Vendor Assessment Agreements",
      link: "newratingagreements",
      dateModel: "double",
      id: "2",
    },

  ];

  
  const [sendingReq, setsendingReq] = useState(false);
  const [open, setOpen] = useState(false);
  const [sindleDateFilter, setsindleDateFilter] = useState(false);
  const [searchedLink, setsearchedLink] = useState();
  const [searchedName, setsearchedName] = useState();
  const [StartDate, setStartDate] = useState();
  const [EndDate, setEndDate] = useState();
  const [startDate, setstartDate] = useState()
  const [endDate, setendDate] = useState()
  const [value, setValue] = React.useState([null, null]);
  const history = useNavigate();

  const style = {
    position: "absolute",
    top: "35%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleSearch = (event, newValue) => {
    setsendingReq(true);
    event.preventDefault();
    if (newValue !== null) {
      if (newValue.dateModel === "none") {
        window.open(`/Reports/${newValue.link}`, "_blank");
      } else {
        setOpen(true);
        setsearchedName(newValue.name);
        setsearchedLink(newValue.link);
        if (newValue.dateModel === "single") setsindleDateFilter(true);
        else setsindleDateFilter(false);
      }
    }
  };

  const onSubmit = () => {
    setsendingReq(true);
    if (StartDate !== null && EndDate !== null) {
      if(startDate != null && startDate != ""){
        if(endDate != null){
          localStorage.setItem("reportsfirstDate", startDate)
          localStorage.setItem("reportslastDate", endDate)
          window.open(`/Reports/${searchedLink}`, "_blank");
        }
        else{
          const date = new Date();
          var month = date.getMonth() + 1
          if(month < 10){
            month = `0${month}`
          }
          var current_date = date.getDate();
          if(current_date < 10){
            current_date = `0${current_date}`
          }
          const getdate = `${date.getFullYear()}-${month}-${current_date}`;
          localStorage.setItem("reportsfirstDate", startDate)
          localStorage.setItem("reportslastDate", getdate);
          window.open(`/Reports/${searchedLink}`, "_blank");
          }
      }
      else{
        alert("add date 1")
      }
    }
  };

  return (
    <>
      <div style={{height: "90vh"}}>
        <div className="col-md-4 mx-auto mt-2 vh-30 p-1 pe-2">
          <Stack>
            <Autocomplete
              id="val"
              freeSolo
              disableClearable
              options={GridHeadings}  
              getOptionLabel={(option) => `${option.id}:  ${option.name}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search for Reports"
                  variant="outlined"
                />
              )}
              onChange={handleSearch}
            />
          </Stack>
        </div>
        <div className="row mt-5 p-3">
          <div
            // className="card"
            style={{
              // backgroundColor: "#e0e0e0",
              // height: "400px",
              // overflow: "scroll",
            }}
          >
            <div className="row pt-3 pb-lg-3 ps-lg-4 p-3 ps-lg-3 mx-auto">
              {GridHeadings.map((value, index) => {
                return (
                  <>
                    <Card
                      className="card col-12 col-md-3 col-lg-3 ms-md-5 ms-lg-5 mb-2 fs-6"
                      id={index}
                      sx={{
                        backgroundImage: `url(${white})`,
                        backgroundColor: "white",
                        backgroundSize: "cover",
                        height : "100%"
                      }}
                    >
                      <CardContent
                        onClick={() => {
                          localStorage.removeItem("reportsfirstDate");
                          localStorage.removeItem("reportslastDate");
                          // document.getElementById(index).style.backgroundColor = "red"
                          window.open(`Reports/${value.link}`, "_blank");
                        }}
                      >
                        <Typography
                          className="fw-bold text-capitalize mx-auto"
                          sx={{color: "black", fontFamily: "Kalinga", fontStyle:'bold', fontSize:'15px', textShadow: "1px 1px white, -1px 1px white, 1px -1px white, -1px -1px white"}}
                          // color="black"
                          gutterBottom
                        >
                          {`${value.id}- ${value.name}`}
                        </Typography>
                      </CardContent>
                    </Card>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="col-md-8 mx-auto"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Select Date Range for
          </Typography>
          <Typography className="text-warning" variant="h5">
            {searchedName}
          </Typography>
          <Box className="row">
            <TextField
              type="date"
              id="startDate"
              onChange={(e) =>
                setstartDate(e.target.value)
              }
              className="btn_theme my-1"
              variant="outlined"
            />
            {sindleDateFilter ? null : (
              <TextField
                type="date"
                id="endDate"
                onChange={(e) =>
                  setendDate(e.target.value)
                }
                className="btn_theme my-1"
                variant="outlined"
              />
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className="btn_theme my-1"
              onClick={onSubmit}
            >
              Search
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}